"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUpdateDeliveryErrorResponse = exports.UpdateDeliveryFailedEvent = exports.Name = void 0;
var _failedEventData = require("@ori-events/failed-event-data");
const Name = exports.Name = 'update-delivery-failed';
const UpdateDeliveryFailedEvent = exports.UpdateDeliveryFailedEvent = Name;
const isUpdateDeliveryErrorResponse = response => (0, _failedEventData.isErrorResponse)(response);
exports.isUpdateDeliveryErrorResponse = isUpdateDeliveryErrorResponse;
